module.exports = __webpack_public_path__ + "static/media/main.eaafe607.jpg";